import {Injectable, EventEmitter} from '@angular/core';
import {Asset} from '../api/models/asset';
import {Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CompanySharedService {
  // Global Search
  searchFilter = new Subject<string>();
  setCurrentView = new EventEmitter();

  // Discovery Settings Actions
  companyScanEVE = new EventEmitter();

  // Asset Actions
  showAssetTable = false;
  jobsUpdateEVE = new EventEmitter();
  cmpScanEVE = new EventEmitter();
  assetTableView = new EventEmitter();
  globalFilterEVE = new EventEmitter();
  addAssetEVE = new EventEmitter();
  refreshAssetEVE = new EventEmitter();
  updateAssetEVE = new EventEmitter();
  assetScanEVE = new EventEmitter();
  firewallScanEVE = new EventEmitter();
  downloadReportEVE = new EventEmitter();
  assetFilterEVE = new EventEmitter();
  currentAsset!: Asset;
  externalScanEVE = new EventEmitter();
  remediationSuppressEVE = new EventEmitter();
  rmPatchEvent: Subject<any> = new Subject<any>();
  rmViewAssetsEvent: Subject<any> = new Subject<any>();
  rmViewEvidence: Subject<any> = new Subject<any>();
  totalEVE: Subject<any> = new Subject<any>();
  reloadAndSetCompanyEVE: Subject<any> = new Subject<any>();
  jobsViewEVE: Subject<any> = new Subject<any>();
  filterUpdateEVE: Subject<any> = new Subject<any>();
  filterUpdate = new Subject<string>();
  reportFilterUpdate = new Subject<string>();
  selectAllUpdate = new Subject<boolean>();
  updateTag = new Subject<any>();
  updateImportance = new Subject<any>();
  selectedAssets: boolean | undefined = false;
  filteredData = new Subject<any>();
  runReconEVE = new EventEmitter();
  rollBackReconEVE = new EventEmitter();
  downloadFromAgGridEVE = new EventEmitter();
  saveFromAgGridEVE = new EventEmitter();
  addColumnFromAgGridEVE = new EventEmitter();
  saveTableFromAgGridEVE = new EventEmitter();
  rejectRecordsFromAgGridEVE = new EventEmitter();
  toggleSidebarEVE = new EventEmitter();
  toggleSideMenuBarEVE = new EventEmitter();
  changeEDateEVE = new EventEmitter();
  refreshAgGridEVE = new EventEmitter();
  glClickedEventData = new EventEmitter();
  allRecordsClicked = new EventEmitter();
  holdOptionForSapEVE = new EventEmitter();
  forceMatchDownloadEVE = new EventEmitter();
  // Shared Keys
  totals: any =  {};
  assetFilter = '';
  reportFilter: any;

  constructor() {
    this.searchFilter.pipe( debounceTime(500), distinctUntilChanged()) .subscribe(value => {
      this.globalFilterEVE.next(value);
    });
    this.filterUpdate.pipe(debounceTime(1500), distinctUntilChanged()).subscribe(value => {
      this.filterUpdateEVE.next(value);
    });
  }

  getFilterData(data: any) {
    this.filteredData.next({data})
  } 

  showAssetTableView(value: any): void {
    this.showAssetTable = value;
    this.assetTableView.next({value});
  }

  setCurrentCompany(company: string): void {
    this.reloadAndSetCompanyEVE.next({value: company});
  }

  companyScan(scanType: string): void {
    this.companyScanEVE.next({st: scanType});
  }

  addAsset(): void {
    this.addAssetEVE.next({});
  }
  addRecon(): void {
    this.addAssetEVE.next({});
  }

  reloadAsset(): void {
    this.refreshAssetEVE.next({});
  }

  updateAsset(): void {
    this.updateAssetEVE.next({});
  }

  firewallScan(): void {
    this.firewallScanEVE.next({});
  }

  assetScan(val: any): void {
    this.assetScanEVE.next({value: val});
  }

  downloadReport(): void {
    this.downloadReportEVE.next({});
  }

  externalScan(): void {
    this.externalScanEVE.next({});
  }

  suppressRemediation(): void {
    this.remediationSuppressEVE.next({});
  }

  patchRemediation(): void {
    this.rmPatchEvent.next({});
  }

  viewRemediationAssets(): void {
    this.rmViewAssetsEvent.next({});
  }

  viewRemediateEvidence(): void {
    this.rmViewEvidence.next({});
  }
  /////// RECON FUNCTIONS ///////
  runRecon(): void {
    this.runReconEVE.next({});
  }

  rollBackRecon(): void {
    this.rollBackReconEVE.next({});
  }
  refreshTable(): void {
    this.refreshAgGridEVE.next({});
  }
  glClickedEvent(data: any, value: any): void {
    this.glClickedEventData.next({data, value});
  }
  clickedAllRecords(data: any): any {
    this.allRecordsClicked.next(data);
  }
  downloadFromAgGrid(value: any): void {
    this.downloadFromAgGridEVE.next(value);
  }
  saveFromAgGrid(): void {
    this.saveFromAgGridEVE.next({});
  }
  addColumnFromAgGrid(): void {
    this.addColumnFromAgGridEVE.next({});
  }
  saveTableFromAgGrid(): void {
    this.saveTableFromAgGridEVE.next({});
  }
  rejectRecordsFromAgGrid(): void {
    this.rejectRecordsFromAgGridEVE.next({});
  }
  toggleSidebar(): void {
    this.toggleSidebarEVE.next({});
  }
  toggleSideBarMenu(value: any): void {
    this.toggleSideMenuBarEVE.next(value)
  }
  changeEDate(value: any): void {
    this.changeEDateEVE.next(value)
  }
  holdOptionForSap(value: any): void {
    this.holdOptionForSapEVE.next(value)
  }
  forceMatchDownload(): void {
    this.forceMatchDownloadEVE.next({})
  }
}
